import { RootState } from '@reducers';

export const selectFeatureInsurer = (state: RootState) => state.featureReducer.insurerReducer;
